<template>
  <div :class="$style.ctn">
    <PaginationTable
      :class="$style.table"
      :head="debugHead"
      :values="debug"
      not-found-message="No debug info"
      :table-wrapper-class="media.debugTableWrapper"
    >
      <template #cell="{ cell, i }">
        <b v-if="i === 0">
          {{ cell }}
        </b>
      </template>
    </PaginationTable>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import PaginationTable from './PaginationTable.vue';

export default defineComponent({
  components: { PaginationTable },
  inject: ['root'],
  data: () => ({
    debugHead: [
      { value: 'Process', width: 228 },
      { value: 'Message', width: 852 },
    ],
  }),
  computed: {
    debug() {
      return this.root.debugOutputStrings.values;
    },
  },
});
</script>

<style lang="scss" module>
.ctn {
  padding-top: 20px;
}
.table td * {
  color: #59606e !important;
}

.table {
  --padding-left-right: 14px;
}
</style>
<style lang="scss" src="./media.module.scss" module="media"></style>
